<template>
    <div class="card shadow-sm">
        <div class="card-header py-1 px-2">
            <strong>待辦清單</strong>
        </div>
        <ul class="list-group list-group-flush rounded-0 border-top-0">
            <tasklet-item v-for="tasklet in tasklets"
                          v-bind:key="tasklet._id"
                          v-bind:task="tasklet"
                          v-on:change="save">
            </tasklet-item>
        </ul>
    </div>
</template>

<script>
import TaskletItem from "./TaskletItem";
export default {
    name: "TaskletList",
    components: {
        TaskletItem,
    },
    props: {
        "taskId": {
            type: String,
        },
        "tasklets": {
            type: Array,
        },
    },
    data () {
        return {

        };
    },
    computed: {

    },
    methods: {
        async save (tasklet) {
            const targetIndex = this.tasklets
                .findIndex(
                    ({ _id }) => _id === tasklet._id
                );
            this.tasklets
                .splice(
                    targetIndex,
                    1,
                    tasklet
                );
            try {
                await this.$store
                    .dispatch(
                        "tasks/edit",
                        {
                            "_id": this.taskId,
                            "tasks": this.tasklets
                        }
                    );
            } catch (e) {
                console.error(e);
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.card-header {
    font-size: 0.9rem;
}
</style>
